import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";

import { Singleton } from "../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { OfficeEditor } from "../../erp/cellEditor/Office/OfficeEditor";
import { _AttentionOffice } from "../../../core/services/dataBean/EntityCatalog";
import { AccountEditor } from "../../editor/AccountEditor";
import { SelectSiteID } from "../../admin/configuracion/SiteID/SelectSiteID";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectIndirectConstType } from "../IndirectCostType/SelectIndirectConstType";


export const AttentionOffice = () => {

    const AttentionOffice = useDataBean(_AttentionOffice);
    const single = Singleton.getInstance();
    const [office, setOffice] = useState<number>(null);
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        AttentionOffice.instance.getAttentionOfficeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        AttentionOffice.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        AttentionOffice.deleteItemVoid(AttentionOffice.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": ``, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        AttentionOffice.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDAttentionOffice', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo Costo para Materia Prima', property: 'IndirectCostTypeForRawMaterialName', visible: true },
        { title: 'Almacén en Transito para Inventario de Ordenes de Poducción', property: 'StoreForRawMaterialTransitToOPName', visible: true },
        { title: 'Almacén de Producto Terminado', property: 'StoreForFinishedProductName', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Coordinador', property: 'EmployeeName', visible: true },
        { title: 'Ubicación', property: 'IDLnSiteID', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${AttentionOffice.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Centros de Fabricación/Producción ">
            <div className="row">

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={AttentionOffice.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor label="Coordinador" idAccount={AttentionOffice.bean.IDAccount} onChange={(e) => { AttentionOffice.setBean({ ...AttentionOffice.bean, "IDAccount": e.IDAccount }) }}></AccountEditor>

                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={AttentionOffice.bean.Name} onChange={AttentionOffice.handleChange} />
                                {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                            </div>
                            <div className="col-md-6">
                                <label>Tipo Costo para Materia Prima</label>
                                <SelectIndirectConstType idSelector={AttentionOffice.bean.IDIndirectCostTypeForRawMaterial} onChange={(e) => { AttentionOffice.setBean({ ...AttentionOffice.bean, "IDIndirectCostTypeForRawMaterial": e.IDIndirectCostType }) }} label=" " returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <SelectStoreEditor label='Almacén en Transito para Inventario de Ordenes de Poducción' idSelector={AttentionOffice.bean.IDStoreForRawMaterialTransitToOP} onChange={(e: any) => { AttentionOffice.setBean({ ...AttentionOffice.bean, "IDStoreForRawMaterialTransitToOP": e.IDStore }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectStoreEditor label='Almacén de Producto Terminado' idSelector={AttentionOffice.bean.IDStoreForFinishedProduct} onChange={(e: any) => { AttentionOffice.setBean({ ...AttentionOffice.bean, "IDStoreForFinishedProduct": e.IDStore }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectSiteID label="Ubicación" edit idLnSite={AttentionOffice.bean.IDLnSiteID} onChange={(e) => { AttentionOffice.setBean({ ...AttentionOffice.bean, "IDLnSiteID": e.IDLn }) }} />
                            </div>


                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={AttentionOffice.bean.Description} onChange={AttentionOffice.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {AttentionOffice.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}